import './index.scss';
import React, { useEffect, useState } from 'react';
import Button from '~/components/button';
import types from '~/redux/constants';
const ErrorPage = ({ error, info }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    useEffect(() => {
        window.dispatchAction(types.appState.SET_ERROR_TRY_AGAIN, { errorTryAgain: true });
    }, []);
    return (React.createElement("div", { className: 'error-page' },
        React.createElement("h2", null, "There's been an Error"),
        React.createElement("p", { className: 'text-center' }, "Try again or contact support if the problem persists."),
        React.createElement("hr", null),
        React.createElement("div", { className: 'error-actions' },
            window.RG_CONFIG.DEBUG && React.createElement(Button, { onClick: () => setIsExpanded(!isExpanded) }, isExpanded ? 'Hide technical details' : 'Show technical details'),
            React.createElement(Button, { onClick: () => window.location.replace('/') }, "Home"),
            React.createElement(Button, { onClick: () => window.location.reload() }, "Refresh")),
        isExpanded && React.createElement("div", { className: 'technical-details' },
            React.createElement("h4", null,
                (error === null || error === void 0 ? void 0 : error.name) || 'Error',
                ":"),
            (error === null || error === void 0 ? void 0 : error.message) || 'Unknown Error',
            (error === null || error === void 0 ? void 0 : error.stack) && React.createElement(React.Fragment, null,
                React.createElement("h4", null, "Stacktrace:"),
                error.stack,
                React.createElement("br", null),
                React.createElement("br", null)),
            info && React.createElement(React.Fragment, null,
                React.createElement("h4", null, "Info:"),
                info.digest))));
};
export default ErrorPage;
